import { motion, useSpring } from 'framer-motion';

const slideInOutRight = {
	initial: {
		// x: '-100vw',
		opacity: 0,
	},
	animate: {
		// x: 0,
		opacity: 1,
		transition: {
			type: 'spring',
			bounce: 0.2,
			delay: 1,
			duration: 2,
		},
	},
	exit: {
		// x: '100vw',
		opacity: 0,
	},
};

// const slideInOutLeft = {
//     initial: {
//         x: '100vw',
//         opacity: 1,
//     },
//     animate: {
//         x: 0,
//         opacity: 1,
//         transition: {
//             type: 'spring',
//             bounce: 0.2,
//             delay: 0.5,
//             duration: 1.5,
//         },
//     },
//     exit: {
//         x: '-100vw',
//         opacity: 1,
//     },
// };

const AnimatedPage = ({ children }) => {
	return (
		<motion.div
			variants={slideInOutRight}
			initial="initial"
			animate="animate"
			exit="exit"
			transition={{ duration: 1, ease: 'easeInOut' }}
		>
			{children}
		</motion.div>
	);
};

export default AnimatedPage;
